import { Modal, Header, Button } from 'semantic-ui-react';

function Confirm({ open, handleYes, handleNo, header_content, body_content, loading }) {
	return (
		<Modal
			open={open}
			closeIcon
			onClose={handleNo}
		>

			<Header content={header_content} />

			<Modal.Content>
				<p>{body_content}</p>
			</Modal.Content>

			<Modal.Actions>
				<Button color="red" onClick={handleNo}>No</Button>
				<Button color="green" loading={loading} onClick={handleYes}>Yes</Button>
			</Modal.Actions>
		</Modal>
	)
}

export default Confirm;
